import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ObjectsListComponent} from './objects-list/objects-list.component';
import {ObjectViewComponent} from './object-view/object-view.component';
import {ObjectFormComponent} from './object-form/object-form.component';
import {StaffListComponent} from './subpages/staff-list/staff-list.component';
import {EquipmentListComponent} from './subpages/equipment-list/equipment-list.component';
import {SpecialistsResolverService} from '@providers/_resolvers/specialists-resolver.service';
import {WorkingObjectsResolver} from './services/working-objects.resolver';
import {BlankWorkingObjectResolver} from './services/blank-working-object.resolver';
import {WorkingObjectSpecialistsResolver} from './services/working-object-specialists.resolver';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {TechnicalDeviceListComponent} from './subpages/technical-device-list/technical-device-list.component';
import {FilteredWorkingObjectsResolver} from './services/filtered-working-objects.resolver';
import {FilteredTechnicalDevicesResolver} from './services/filtered-technical-devices.resolver';
import {RoutesStorage} from '@helpers/routes.helper';
import {EquipmentListPagesResolver} from './services/equipment-list/equipment-list-pages.resolver';

export const objectsListRoutes: Routes = [
    {
        path: '',
        component: ObjectsListComponent,
        canActivate: [CheckPermissionsGuardService],
        data: {
            title: 'Объекты',
            permissions: [
                UserNamespace.Permission.workingObjectList,
            ],
        },
        resolve: {
            data: FilteredWorkingObjectsResolver,
        }
    },
];

export const objectsModuleRoutes: Routes = [
    {
        path: '',
        canActivate: [CheckPermissionsGuardService],
        data: {
            permissions: [
                UserNamespace.Permission.workingObjectList,
            ],
        },
        children: [
            {
                path: 'new',
                component: ObjectFormComponent,
                canActivate: [CheckPermissionsGuardService],
                data: {
                    title: 'Новый объект',
                    permissions: [
                        UserNamespace.Permission.workingObjectCreate,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list
                },
                resolve: {
                    data: BlankWorkingObjectResolver,
                    specialists: SpecialistsResolverService,
                }
            },
            {
                path: ':id/view',
                component: ObjectViewComponent,
                canActivate: [CheckPermissionsGuardService],
                data: {
                    title: 'Просмотр объекта',
                    permissions: [
                        UserNamespace.Permission.workingObjectView,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list
                },
                resolve: {
                    data: WorkingObjectsResolver,
                },
                children: [
                    {
                        path: '',
                        redirectTo: 'technical-device',
                        pathMatch: 'full'
                    },
                    {
                        path: 'staff',
                        component: StaffListComponent,
                        data: {
                            title: 'Просмотр объекта',
                            scrollTop: false
                        },
                        resolve: {
                            data: WorkingObjectSpecialistsResolver,
                            specialists: SpecialistsResolverService,
                        }
                    },
                    {
                        path: 'equipment',
                        component: EquipmentListComponent,
                        data: {
                            title: 'Просмотр объекта',
                            scrollTop: false
                        },
                        resolve: {
                            data: EquipmentListPagesResolver,
                        }
                    },
                    {
                        path: 'technical-device',
                        component: TechnicalDeviceListComponent,
                        canActivate: [CheckPermissionsGuardService],
                        data: {
                            title: 'Просмотр объекта',
                            scrollTop: false,
                            permissions: [
                                UserNamespace.Permission.workingObjectTechnicalDeviceView,
                                UserNamespace.Permission.technicalDeviceList,
                            ],
                            fallbackUrl: '../../staff',
                            fallbackByRelative: true
                        },
                        resolve: {
                            data: FilteredTechnicalDevicesResolver,
                        }
                    }
                ]
            },
            {
                path: ':id/edit',
                component: ObjectFormComponent,
                canActivate: [CheckPermissionsGuardService],
                data: {
                    title: 'Редактирование объекта',
                    permissions: [
                        UserNamespace.Permission.workingObjectUpdate,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list
                },
                resolve: {
                    data: WorkingObjectsResolver,
                    specialists: SpecialistsResolverService,
                },
            },
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(objectsModuleRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class ObjectsRoutingModule {}
